import { AssignmentContextsResponse, AssignmentRule } from './auth-context.models';
import { BASELINE_KEY_TO_MODULE } from './module-baseline-key.map';

export function toAssignmentRules(groups: AssignmentContextsResponse): AssignmentRule[] {
  const rules: AssignmentRule[] = [];

  for (const group of groups) {
    if (group.kind === 'Site' && group.site) {
      const { site } = group;
      const moduleKeys = BASELINE_KEY_TO_MODULE[site.siteTypePositionBaselineKey];
      if (!moduleKeys) {
        continue;
      }

      site.assignmentIds.forEach((assignmentId, i) => {
        const unit = site.sites[i];
        for (const moduleKey of moduleKeys) {
          rules.push({
            moduleKey,
            kind: group.kind,
            baselineKey: site.siteTypePositionBaselineKey,
            positionTitle: group.positionTitle,
            assignmentId: null,
            siteTypePositionId: site.siteTypePositionId,
            departmentPositionId: null,
            unitId: unit?.id ?? site.siteIds[i],
            unitLabel: unit?.name ?? '',
            isPrimary: group.isPrimary,
          });
        }
      });
    }

    if (group.kind === 'Department' && group.department) {
      const dept = group.department;
      const moduleKeys = BASELINE_KEY_TO_MODULE[dept.departmentPositionBaselineKey];
      if (!moduleKeys) {
        continue;
      }

      for (const moduleKey of moduleKeys) {
        rules.push({
          moduleKey,
          kind: group.kind,
          baselineKey: dept.departmentPositionBaselineKey,
          positionTitle: group.positionTitle,
          positionKey: dept.positionKey ?? null,
          assignmentId: dept.assignmentId,
          siteTypePositionId: null,
          departmentPositionId: dept.departmentPositionId,
          unitId: dept.departmentId,
          unitLabel: dept.departmentName,
          isPrimary: group.isPrimary,
        });
      }
    }
  }

  return rules;
}
